<div class="loading" *ngIf="show$ | async" [class.transparent]="transparent">
  <div class="bar"></div>
</div>
